import { render, staticRenderFns } from "./fdInventory36.vue?vue&type=template&id=0ed8631d"
import script from "./fdInventory36.vue?vue&type=script&lang=js"
export * from "./fdInventory36.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports